/* ============================================================
   ADEQO PANEEL-VILT — van PET-fles tot akoestisch vilt, getekend in
   één SVG (product-vilt-adeqo). Vier fases die in elkaar overlopen:
   0 flessen, 1 vlokken, 2 vezels, 3 viltplaat, daarna op de plaat
   4 geluidsbogen uit een luidspreker die in het vilt wegzakken (klasse A) en 5 een vlamtest op de rand waarna het vilt zelf dooft (B-s1,d0). Elk deeltje heeft per
   fase een eigen plek, lengte en dikte; daartussen wordt geïnterpoleerd.
   Loopt alleen als de tekening in beeld is; bij reduced motion staat
   meteen de viltplaat er.

   Op de box [data-paneel-vilt]:
     [data-pv-svg]          lege <svg>
     data-felt="#2c2c2c"    viltkleur van dit product
     [data-pv-step="0..5"]  stappen onder de tekening (tekst uit Liquid)
     [data-pv-badge]        labels "sound" en "fire" over de tekening;
                            in "fire" drie [data-pv-row] (B, s1, d0)
   ============================================================ */

(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var a in attrs) n.setAttribute(a, attrs[a]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function hexToRgb(x) { x = (x || '').replace('#', ''); if (x.length === 3) x = x[0] + x[0] + x[1] + x[1] + x[2] + x[2]; return [parseInt(x.substr(0, 2), 16), parseInt(x.substr(2, 2), 16), parseInt(x.substr(4, 2), 16)]; }
  function shade(hex, f) { var c = hexToRgb(hex); return [c[0] * f, c[1] * f, c[2] * f].map(function (v) { return Math.max(0, Math.min(255, v)); }); }
  function rgb(c) { return 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')'; }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function mount(box) {
    if (!box || box.__paneelVilt) return;
    box.__paneelVilt = true;
    var svg = box.querySelector('[data-pv-svg]');
    if (!svg) return;
    var felt = box.getAttribute('data-felt') || '#2c2c2c';
    var steps = box.querySelectorAll('[data-pv-step]');

    var seed = 11;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }

    svg.setAttribute('viewBox', '30 140 460 228');
    svg.innerHTML = '';
    var uid = 'pv' + Math.random().toString(36).slice(2, 7);
    var defs = el('defs', {}, svg);

    // Zachte schaduw op de vloer, blijft altijd staan
    var sh = el('radialGradient', { id: uid + 's' }, defs);
    el('stop', { offset: 0, 'stop-color': '#000', 'stop-opacity': 0.13 }, sh);
    el('stop', { offset: 1, 'stop-color': '#000', 'stop-opacity': 0 }, sh);
    el('ellipse', { cx: 260, cy: 338, rx: 200, ry: 26, fill: 'url(#' + uid + 's)' }, svg);

    /* ---------- Fase 0: twee lege, licht gedeukte flessen ---------- */
    var bottles = el('g', {}, svg);
    var BOTTLES = [
      { x: 232, y: 262, r: -7, s: 1 },
      { x: 300, y: 300, r: 9, s: 0.92 }
    ];
    var bodyGrad = el('linearGradient', { id: uid + 'b', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    el('stop', { offset: 0, 'stop-color': '#eef5f9', 'stop-opacity': 0.95 }, bodyGrad);
    el('stop', { offset: 0.45, 'stop-color': '#cfe1ec', 'stop-opacity': 0.75 }, bodyGrad);
    el('stop', { offset: 1, 'stop-color': '#a9c6d8', 'stop-opacity': 0.85 }, bodyGrad);
    function bottlePath() {
      // Romp van -100 tot 60 (straal 30, met deuken), schouder tot 86,
      // hals tot 96. Dop los getekend.
      var top = [], bot = [], i, x, d;
      for (i = 0; i <= 8; i++) {
        x = -100 + i * 20;
        d = (i === 0 || i === 8) ? 0 : (rnd() - 0.5) * 9;
        top.push([x, -30 + Math.abs(d) * 0.6 + (i === 0 ? 6 : 0)]);
        bot.push([x, 30 - Math.abs(d) * 0.4 - (i === 0 ? 6 : 0)]);
      }
      var p = 'M' + top[0][0] + ' ' + top[0][1];
      for (i = 1; i < top.length; i++) p += ' L' + top[i][0].toFixed(1) + ' ' + top[i][1].toFixed(1);
      p += ' C74 -30 80 -12 86 -11 L96 -11 L96 11 L86 11 C80 12 74 30 60 30';
      for (i = bot.length - 1; i >= 0; i--) p += ' L' + bot[i][0].toFixed(1) + ' ' + bot[i][1].toFixed(1);
      p += ' Q-106 0 ' + top[0][0] + ' ' + top[0][1] + 'Z';
      return p;
    }
    BOTTLES.forEach(function (b) {
      var g = el('g', { transform: 'translate(' + b.x + ' ' + b.y + ') rotate(' + b.r + ') scale(' + b.s + ')' }, bottles);
      el('path', { d: bottlePath(), fill: 'url(#' + uid + 'b)', stroke: '#93b2c6', 'stroke-width': 1.3, 'stroke-linejoin': 'round' }, g);
      // Deuken en glans
      for (var c = 0; c < 6; c++) {
        var cx = -88 + c * 26 + rnd() * 8;
        el('path', { d: 'M' + cx + ' -26 Q' + (cx + 6) + ' 0 ' + (cx - 2) + ' 26', fill: 'none', stroke: '#9fbccd', 'stroke-width': 0.9, opacity: 0.7 }, g);
      }
      el('path', { d: 'M-88 -16 L52 -18', stroke: '#fff', 'stroke-width': 4, 'stroke-linecap': 'round', opacity: 0.75 }, g);
      el('rect', { x: 96, y: -13, width: 15, height: 26, rx: 3, fill: '#5d8fbf' }, g);
      el('path', { d: 'M100 -13 V13 M104 -13 V13 M108 -13 V13', stroke: '#4c7aa6', 'stroke-width': 1 }, g);
    });

    /* ---------- Fase 3: de viltplaat (isometrisch) ---------- */
    var O = [258, 268], U = [118, -44], Vv = [78, 34], T = 17;
    function pt(a, b) { return [O[0] + a * U[0] + b * Vv[0], O[1] + a * U[1] + b * Vv[1]]; }
    function poly(g, a, fill) { return el('polygon', { points: a.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '), fill: fill }, g); }
    var c1 = pt(-1, -1), c2 = pt(1, -1), c3 = pt(1, 1), c4 = pt(-1, 1);
    function dn(p) { return [p[0], p[1] + T]; }
    var slab = el('g', {}, svg);
    var topGrad = el('linearGradient', { id: uid + 't', x1: 0, y1: 0, x2: 1, y2: 1 }, defs);
    el('stop', { offset: 0, 'stop-color': rgb(shade(felt, 1.25)) }, topGrad);
    el('stop', { offset: 1, 'stop-color': rgb(shade(felt, 1.02)) }, topGrad);
    poly(slab, [c1, c4, dn(c4), dn(c1)], rgb(shade(felt, 0.85)));
    poly(slab, [c4, c3, dn(c3), dn(c4)], rgb(shade(felt, 0.7)));
    poly(slab, [c1, c2, c3, c4], 'url(#' + uid + 't)');
    // Viltstructuur: fijne vezelruis over alle zichtbare vlakken, plus spikkels
    var fz = el('filter', { id: uid + 'fz', x: 0, y: 0, width: '100%', height: '100%' }, defs);
    el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.9 0.55', numOctaves: 3, seed: 7, result: 'n' }, fz);
    el('feColorMatrix', { type: 'matrix', values: '0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 0.9 -0.35' }, fz);
    var fzD = el('filter', { id: uid + 'fd', x: 0, y: 0, width: '100%', height: '100%' }, defs);
    el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.7 1.1', numOctaves: 2, seed: 3, result: 'n' }, fzD);
    el('feColorMatrix', { type: 'matrix', values: '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1.1 -0.4' }, fzD);
    var slabClip = el('clipPath', { id: uid + 'sc' }, defs);
    poly(slabClip, [c1, c2, c3, dn(c3), dn(c4), dn(c1)], '#000');
    var tex = el('g', { 'clip-path': 'url(#' + uid + 'sc)' }, slab);
    el('rect', { x: 40, y: 150, width: 440, height: 220, filter: 'url(#' + uid + 'fz)', opacity: 0.16 }, tex);
    el('rect', { x: 40, y: 150, width: 440, height: 220, filter: 'url(#' + uid + 'fd)', opacity: 0.35 }, tex);
    // Lichte rand langs de voorste bovenkanten
    el('path', { d: 'M' + c1[0] + ' ' + c1[1] + ' L' + c4[0] + ' ' + c4[1] + ' L' + c3[0] + ' ' + c3[1], fill: 'none', stroke: rgb(shade(felt, 1.9)), 'stroke-width': 0.8, opacity: 0.5 }, slab);
    for (var sp = 0; sp < 260; sp++) {
      var q = pt(rnd() * 1.94 - 0.97, rnd() * 1.94 - 0.97);
      el('circle', { cx: q[0].toFixed(1), cy: q[1].toFixed(1), r: (0.4 + rnd() * 0.7).toFixed(2), fill: rgb(shade(felt, rnd() < 0.5 ? 1.55 : 0.8)), opacity: 0.55 }, slab);
    }
    // Maat: 9 mm langs de rechterhoek
    var dim = el('g', { 'class': 'pv-dim' }, slab);
    var dx = c3[0] + 16;
    el('path', { d: 'M' + (c3[0] + 4) + ' ' + c3[1] + 'H' + (dx + 4) + 'M' + (c3[0] + 4) + ' ' + (c3[1] + T) + 'H' + (dx + 4) + 'M' + dx + ' ' + c3[1] + 'V' + (c3[1] + T), fill: 'none' }, dim);
    var tt = el('text', { x: dx + 8, y: c3[1] + T / 2 + 4 }, dim); tt.textContent = box.getAttribute('data-dikte') || '9 mm';

    /* ---------- Fase 4: geluid loopt het vilt in ---------- */
    // Een kleine luidspreker rechtsboven (zelfde stijl als de testbrander)
    // stuurt strakke geluidsbogen naar het vilt. Waar ze aankomen zakken ze
    // weg als een zachte ring in het oppervlak; er kaatst alleen een kleine,
    // vage boog terug.
    var S0 = pt(0.05, -0.15), SPK = [438, 176];
    var sdx = S0[0] - SPK[0], sdy = S0[1] - SPK[1], SD = Math.sqrt(sdx * sdx + sdy * sdy);
    var SA = Math.atan2(sdy, sdx), SDIR = [sdx / SD, sdy / SD];
    var MOUTH = [SPK[0] + SDIR[0] * 8, SPK[1] + SDIR[1] * 8], REACH = SD - 8;
    var sound = el('g', { 'class': 'pv-sound' }, svg);
    var topClip = el('clipPath', { id: uid + 'tc' }, defs);
    poly(topClip, [c1, c2, c3, c4], '#000');
    var ripG = el('g', { 'clip-path': 'url(#' + uid + 'tc)' }, sound);
    var wb = el('filter', { id: uid + 'wb', x: '-50%', y: '-50%', width: '200%', height: '200%' }, defs);
    el('feGaussianBlur', { stdDeviation: 0.9 }, wb);
    var rb = el('filter', { id: uid + 'rb', x: '-50%', y: '-50%', width: '200%', height: '200%' }, defs);
    el('feGaussianBlur', { stdDeviation: 1.2 }, rb);
    var NW = 5, WSP = REACH / NW, SPAN = 0.9;
    var waves = [], ripples = [], echoes = [];
    for (var w = 0; w < NW; w++) {
      waves.push(el('path', { fill: 'none', stroke: '#8796a3', 'stroke-width': 3.2, 'stroke-linecap': 'round', filter: 'url(#' + uid + 'wb)' }, sound));
      ripples.push(el('ellipse', { cx: S0[0].toFixed(1), cy: S0[1].toFixed(1), fill: 'none', stroke: '#c3cad1', 'stroke-width': 2, filter: 'url(#' + uid + 'rb)' }, ripG));
      echoes.push(el('path', { fill: 'none', stroke: '#8796a3', 'stroke-width': 1.6, 'stroke-linecap': 'round' }, sound));
    }
    function arc(cx, cy, r, mid, span) {
      var a0 = mid - span, a1 = mid + span;
      return 'M' + (cx + Math.cos(a0) * r).toFixed(1) + ' ' + (cy + Math.sin(a0) * r).toFixed(1) +
        ' A' + r.toFixed(1) + ' ' + r.toFixed(1) + ' 0 0 1 ' + (cx + Math.cos(a1) * r).toFixed(1) + ' ' + (cy + Math.sin(a1) * r).toFixed(1);
    }
    // Weerkaatsing: gespiegeld aan het (vlakke) oppervlak, dus omhoog
    var EA = Math.atan2(-SDIR[1], SDIR[0]);
    // Luidspreker: liggend langs +x getekend, de conus opent naar +x
    var spk = el('g', { transform: 'translate(' + SPK[0] + ' ' + SPK[1] + ') rotate(' + (SA * 180 / Math.PI).toFixed(1) + ')' }, sound);
    var spkIn = el('g', {}, spk);
    var spkGrad = el('linearGradient', { id: uid + 'sg', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    el('stop', { offset: 0, 'stop-color': '#e9ecef' }, spkGrad);
    el('stop', { offset: 0.45, 'stop-color': '#b9bfc5' }, spkGrad);
    el('stop', { offset: 1, 'stop-color': '#7e858c' }, spkGrad);
    el('rect', { x: -30, y: -9, width: 22, height: 18, rx: 5, fill: 'url(#' + uid + 'sg)' }, spkIn);
    el('rect', { x: -22, y: -10, width: 5, height: 20, rx: 2, fill: '#05B175' }, spkIn);
    var cone = el('g', {}, spkIn);
    el('path', { d: 'M-8 -7 L6 -17 Q9 0 6 17 L-8 7 Z', fill: 'url(#' + uid + 'sg)' }, cone);
    el('path', { d: 'M6 -17 Q9 0 6 17', fill: 'none', stroke: '#5d6268', 'stroke-width': 2.4, 'stroke-linecap': 'round' }, cone);
    el('ellipse', { cx: 2, cy: 0, rx: 2.2, ry: 5, fill: '#5d6268' }, cone);
    function drawSound(t, now) {
      sound.style.display = t <= 0 ? 'none' : '';
      if (t <= 0) return;
      // in (0..0,12) en uit (0,88..1) faden; ertussen lopen de bogen door
      var env = Math.min(clamp(t / 0.12), clamp((1 - t) / 0.12));
      spk.setAttribute('opacity', env.toFixed(2));
      spkIn.setAttribute('transform', 'translate(' + ((1 - ease(clamp(t / 0.12))) * 18).toFixed(1) + ' 0)');
      // Conus trilt mee met elke golf
      cone.setAttribute('transform', 'translate(' + (Math.sin(now / 1000 * 95 / WSP * Math.PI * 2) * 0.9 * env).toFixed(2) + ' 0)');
      var run = (now / 1000) * 95;
      for (var w = 0; w < NW; w++) {
        var r = (run + w * WSP) % REACH, f = r / REACH;
        var cx = MOUTH[0], cy = MOUTH[1];
        var o = env * clamp(f / 0.12) * (1 - clamp((f - 0.82) / 0.18));
        waves[w].setAttribute('d', r < 4 ? '' : arc(cx, cy, r + 6, SA, Math.min(SPAN, 20 / (r + 6))));
        waves[w].setAttribute('opacity', o.toFixed(2));
        // Ring in het vilt en kleine echo, vlak nadat deze boog aankwam
        var age = r / REACH;
        var on = age < 0.4 ? 1 - age / 0.4 : 0;
        var rr = 6 + age * 70;
        ripples[w].setAttribute('rx', rr.toFixed(1));
        ripples[w].setAttribute('ry', (rr * 0.45).toFixed(1));
        ripples[w].setAttribute('opacity', (env * on * 0.7).toFixed(2));
        echoes[w].setAttribute('d', age < 0.02 || age > 0.4 ? '' : arc(S0[0], S0[1], 6 + age * 40, EA, Math.min(0.9, 9 / (6 + age * 40))));
        echoes[w].setAttribute('opacity', (env * on * 0.22).toFixed(2));
      }
    }

    /* ---------- Fase 5: vlamtest op de rand, het vilt dooft zelf ---------- */
    // Een slanke testbrander schuift naar de voorkant van de plaat en houdt
    // een strakke vlam tegen de rand. De rand gloeit en schroeit een klein
    // plekje; zodra de brander weggaat dooft het vilt vanzelf (B), stijgt er
    // alleen een dun rookslierje op (s1) en valt er niets naar beneden (d0).
    var FP = pt(0.5, 1), P = [FP[0], FP[1] + T / 2];
    var ANG = 35 * Math.PI / 180, DIR = [Math.cos(ANG), Math.sin(ANG)];
    var GAP = 40; // afstand van de mondstukpunt tot de rand
    var fire = el('g', { 'class': 'pv-fire' }, svg);
    var soft2 = el('filter', { id: uid + 'fg', x: '-100%', y: '-100%', width: '300%', height: '300%' }, defs);
    el('feGaussianBlur', { stdDeviation: 5 }, soft2);
    function lin(id, x2, y2, stops) {
      var g = el('linearGradient', { id: uid + id, x1: 0, y1: 0, x2: x2, y2: y2 }, defs);
      stops.forEach(function (st) { el('stop', { offset: st[0], 'stop-color': st[1], 'stop-opacity': st[2] === undefined ? 1 : st[2] }, g); });
      return 'url(#' + uid + id + ')';
    }
    // Gloed en schroeiplek op het zijvlak (het vlak tussen c4 en c3)
    var faceClip = el('clipPath', { id: uid + 'fc' }, defs);
    poly(faceClip, [c4, c3, dn(c3), dn(c4)], '#000');
    var faceG = el('g', { 'clip-path': 'url(#' + uid + 'fc)' }, fire);
    var heatG = el('radialGradient', { id: uid + 'ht' }, defs);
    el('stop', { offset: 0, 'stop-color': '#ffb347', 'stop-opacity': 0.9 }, heatG);
    el('stop', { offset: 0.5, 'stop-color': '#e2572b', 'stop-opacity': 0.45 }, heatG);
    el('stop', { offset: 1, 'stop-color': '#e2572b', 'stop-opacity': 0 }, heatG);
    var heat = el('ellipse', { cx: P[0], cy: P[1], rx: 34, ry: 14, fill: 'url(#' + uid + 'ht)' }, faceG);
    var charRim = el('ellipse', { cx: P[0], cy: P[1], rx: 0, ry: 0, fill: 'none', stroke: '#ff7a2a', 'stroke-width': 1.4, filter: 'url(#' + uid + 'rb)' }, faceG);
    var char = el('ellipse', { cx: P[0], cy: P[1], rx: 0, ry: 0, fill: '#0c0907', filter: 'url(#' + uid + 'ft)' }, faceG);
    var ember = el('circle', { cx: P[0], cy: P[1], r: 2.2, fill: '#ff9a3c' }, faceG);
    // Rookslierje: een dunne lijn die omhoog wordt "getekend" en vervaagt
    var smokeBlur = el('filter', { id: uid + 'sb', x: '-200%', y: '-50%', width: '500%', height: '200%' }, defs);
    var smT = el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.06 0.04', numOctaves: 2, seed: 5, result: 'n' }, smokeBlur);
    var smO = el('feOffset', { 'in': 'n', dx: 0, dy: 0, result: 'no' }, smokeBlur);
    el('feDisplacementMap', { 'in': 'SourceGraphic', in2: 'no', scale: 9, xChannelSelector: 'R', yChannelSelector: 'G', result: 'd' }, smokeBlur);
    el('feGaussianBlur', { 'in': 'd', stdDeviation: 2.2 }, smokeBlur);
    var smoke = el('path', {
      d: 'M' + P[0] + ' ' + (P[1] - 4) + ' C' + (P[0] - 6) + ' ' + (P[1] - 20) + ' ' + (P[0] + 7) + ' ' + (P[1] - 32) + ' ' + (P[0] + 1) + ' ' + (P[1] - 48) +
         ' S' + (P[0] + 5) + ' ' + (P[1] - 66) + ' ' + (P[0] - 3) + ' ' + (P[1] - 76),
      fill: 'none', stroke: '#a9afb5', 'stroke-width': 5, 'stroke-linecap': 'round', 'stroke-dasharray': '90', 'stroke-dashoffset': '90', opacity: 0,
      filter: 'url(#' + uid + 'sb)'
    }, fire);
    // Brander + vlam in één groep die langs de as beweegt
    var torch = el('g', {}, fire);
    var torchIn = el('g', {}, torch);
    var flameW = el('g', {}, torchIn);
    var fGlow = el('path', { fill: '#ff8a2a', opacity: 0.55, filter: 'url(#' + uid + 'fg)' }, flameW);
    var ft = el('filter', { id: uid + 'ft', x: '-40%', y: '-80%', width: '180%', height: '260%' }, defs);
    var ftT = el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.09 0.05', numOctaves: 2, seed: 2, result: 'n' }, ft);
    var ftO = el('feOffset', { 'in': 'n', dx: 0, dy: 0, result: 'no' }, ft);
    el('feDisplacementMap', { 'in': 'SourceGraphic', in2: 'no', scale: 5, xChannelSelector: 'R', yChannelSelector: 'G', result: 'd' }, ft);
    el('feGaussianBlur', { 'in': 'd', stdDeviation: 0.7 }, ft);
    var flameT = el('g', { filter: 'url(#' + uid + 'ft)' }, flameW);
    var fOut = el('path', { fill: lin('fo', 1, 0, [[0, '#ffd36a', 0.25], [0.2, '#ffb547', 0.95], [0.7, '#ff8a2e', 1], [1, '#ff6a2a', 0.75]]) }, flameT);
    var fIn = el('path', { fill: lin('fi', 1, 0, [[0, '#9cc4ff', 0], [0.35, '#5f9bff', 0.85], [1, '#2f6fe4']]) }, flameT);
    var fHot = el('path', { fill: '#eaf2ff', opacity: 0.8 }, flameT);
    // Brander: liggend getekend langs +x, het mondstuk op x = 0
    var body = el('g', {}, torchIn);
    el('rect', { x: 0, y: -5.5, width: 10, height: 11, rx: 2, fill: '#5d6268' }, body);
    el('rect', { x: 10, y: -9, width: 70, height: 18, rx: 9, fill: lin('tb', 0, 1, [[0, '#e9ecef'], [0.45, '#b9bfc5'], [1, '#7e858c']]) }, body);
    el('rect', { x: 56, y: -10, width: 7, height: 20, rx: 2.5, fill: '#05B175' }, body);
    function flamePath(len, w) {
      // Vlam langs -x vanaf het mondstuk (0,0): ronde voet, spitse punt.
      // Verlopen lopen van punt (links in de bbox) naar blauwe voet (rechts).
      return 'M0 ' + (-w * 0.55) +
        ' C' + (-len * 0.25) + ' ' + (-w) + ' ' + (-len * 0.7) + ' ' + (-w * 0.55) + ' ' + (-len) + ' 0' +
        ' C' + (-len * 0.7) + ' ' + (w * 0.55) + ' ' + (-len * 0.25) + ' ' + w + ' 0 ' + (w * 0.55) +
        ' Q' + (w * 0.5) + ' 0 0 ' + (-w * 0.55) + 'Z';
    }
    var deg = ANG * 180 / Math.PI;
    var lickG = el('g', { filter: 'url(#' + uid + 'ft)' }, fire);
    var lickO = el('path', { fill: lin('lo', 0, 1, [[0, '#ffcf5a', 0], [0.35, '#ffa53a', 0.8], [1, '#ff7a2a', 0.9]]) }, lickG);
    var lickI = el('path', { fill: lin('li', 0, 1, [[0, '#fff3c4', 0], [0.5, '#ffe7a0', 0.85], [1, '#ffd36a', 0.9]]) }, lickG);
    function lickPath(x, y, h, w, lean) {
      var tx = x + lean;
      return 'M' + (x - w) + ' ' + y + ' C' + (x - w) + ' ' + (y - h * 0.5) + ' ' + (tx - w * 0.3) + ' ' + (y - h * 0.8) + ' ' + tx + ' ' + (y - h) +
        ' C' + (tx + w * 0.3) + ' ' + (y - h * 0.8) + ' ' + (x + w) + ' ' + (y - h * 0.5) + ' ' + (x + w) + ' ' + y + ' Z';
    }
    function drawFire(t, now) {
      fire.style.display = t <= 0 ? 'none' : '';
      if (t <= 0) return;
      // Brander schuift in (0..0,14) en weer uit (0,48..0,62)
      var tin = ease(clamp(t / 0.14)), tout = ease(clamp((t - 0.48) / 0.14));
      var off = GAP + (1 - tin) * 70 + tout * 80;
      torch.setAttribute('transform', 'translate(' + (P[0] + DIR[0] * off).toFixed(1) + ' ' + (P[1] + DIR[1] * off).toFixed(1) + ') rotate(' + deg + ')');
      torch.setAttribute('opacity', (Math.min(tin, 1 - tout)).toFixed(2));
      // Vlam: aan van 0,10 tot 0,48, met rustig flakkeren
      var life = ease(clamp((t - 0.1) / 0.06)) * (1 - ease(clamp((t - 0.47) / 0.04)));
      var fk = 1 + Math.sin(now / 70) * 0.06 + Math.sin(now / 37 + 1.3) * 0.04;
      var len = (GAP + 14) * life * fk, w = 9 * (0.4 + life * 0.6);
      if (life < 0.02) { fOut.setAttribute('d', ''); fIn.setAttribute('d', ''); fHot.setAttribute('d', ''); fGlow.setAttribute('d', ''); }
      else {
        fGlow.setAttribute('d', flamePath(len * 1.05, w * 1.8));
        fOut.setAttribute('d', flamePath(len, w));
        fIn.setAttribute('d', flamePath(len * 0.5, w * 0.55));
        fHot.setAttribute('d', flamePath(len * 0.22, w * 0.3));
      }
      flameW.setAttribute('transform', 'translate(0 ' + (Math.sin(now / 90) * 0.5).toFixed(2) + ')');
      ftO.setAttribute('dx', ((now / 9) % 400).toFixed(1));
      // Waar de vlam de rand raakt buigt hij omhoog langs de kant
      var lk = life * (0.85 + Math.sin(now / 47) * 0.1 + Math.sin(now / 23 + 2) * 0.06);
      if (lk < 0.03) { lickO.setAttribute('d', ''); lickI.setAttribute('d', ''); }
      else {
        lickO.setAttribute('d', lickPath(P[0], P[1] + 2, 30 * lk, 9 * lk, Math.sin(now / 120) * 4));
        lickI.setAttribute('d', lickPath(P[0], P[1] + 2, 15 * lk, 4.5 * lk, Math.sin(now / 120) * 2));
      }
      // Rand gloeit zolang de vlam erop staat, schroeiplek groeit een beetje
      heat.setAttribute('opacity', (life * (0.85 + Math.sin(now / 55) * 0.15)).toFixed(2));
      var ch = ease(clamp((t - 0.14) / 0.34));
      char.setAttribute('rx', (7 * ch).toFixed(1)); char.setAttribute('ry', (3.6 * ch).toFixed(1));
      char.setAttribute('opacity', (0.7 * ch).toFixed(2));
      charRim.setAttribute('rx', (7.5 * ch).toFixed(1)); charRim.setAttribute('ry', (4 * ch).toFixed(1));
      // Nagloeien na de vlam, dooft binnen een halve seconde (B)
      var em = t < 0.48 ? 0 : 1 - clamp((t - 0.5) / 0.1);
      ember.setAttribute('opacity', (em * (0.7 + Math.sin(now / 40) * 0.3)).toFixed(2));
      charRim.setAttribute('opacity', (Math.max(life, em) * (0.75 + Math.sin(now / 33) * 0.25)).toFixed(2));
      // Eén dun rookslierje (s1)
      var sm = clamp((t - 0.55) / 0.3);
      smoke.setAttribute('stroke-dashoffset', (90 - sm * 90).toFixed(1));
      smoke.setAttribute('opacity', (Math.sin(sm * Math.PI) * 0.45).toFixed(2));
      smO.setAttribute('dy', (-(now / 14) % 400).toFixed(1));
    }

    /* ---------- Deeltjes ---------- */
    var flakeCols = [[207, 224, 234], [185, 209, 224], [230, 240, 245], [167, 196, 216], [214, 230, 238]];
    var fibreCols = [[226, 230, 233], [205, 211, 216], [236, 238, 240], [214, 219, 223]];
    var feltC = shade(felt, 1.15);
    var parts = [], N = 230, layer = el('g', {}, svg);
    function inBottle(b) {
      var lx = -92 + rnd() * 145, ly = (rnd() - 0.5) * 44, a = b.r * Math.PI / 180;
      return [b.x + (lx * Math.cos(a) - ly * Math.sin(a)) * b.s, b.y + (lx * Math.sin(a) + ly * Math.cos(a)) * b.s];
    }
    for (var i = 0; i < N; i++) {
      var b = BOTTLES[i % 2], s0 = inBottle(b);
      var u = (rnd() + rnd()) - 1, h = 84 * (1 - u * u);
      var fx = 260 + u * 140, fy = 336 - Math.sqrt(rnd()) * h;
      var fp = pt(rnd() * 2.2 - 1.1, rnd() * 2.2 - 1.1);
      var ep = pt(rnd() * 1.8 - 0.9, rnd() * 1.8 - 0.9);
      var fc = flakeCols[i % flakeCols.length], fb = fibreCols[i % fibreCols.length];
      parts.push({
        n: el('path', { 'stroke-linecap': 'round', fill: 'none' }, layer),
        d: rnd() * 0.3,
        st: [
          { x: s0[0], y: s0[1], l: 2, a: rnd() * 6.3, w: 2, c: fc, o: 0, b: 0 },
          { x: fx, y: fy, l: 5 + rnd() * 7, a: rnd() * 6.3, w: 3.5 + rnd() * 3, c: fc, o: 0.95, b: 0 },
          { x: fp[0] + (rnd() - 0.5) * 10, y: fp[1] - 30 + (rnd() - 0.5) * 22, l: 30 + rnd() * 40, a: -0.36 + (rnd() - 0.5) * 0.9, w: 0.6 + rnd() * 0.6, c: fb, o: 0.75, b: (rnd() - 0.5) * 26 },
          { x: ep[0], y: ep[1], l: 16 + rnd() * 10, a: -0.36 + (rnd() - 0.5) * 0.5, w: 0.6, c: feltC, o: 0, b: (rnd() - 0.5) * 6 }
        ]
      });
    }

    function drawParts(from, to, t) {
      parts.forEach(function (p) {
        var k = ease(clamp((t - p.d) / 0.7)), A = p.st[from], B = p.st[to];
        // Rotatie via de kortste weg
        var da = B.a - A.a; while (da > Math.PI) da -= 2 * Math.PI; while (da < -Math.PI) da += 2 * Math.PI;
        var x = lerp(A.x, B.x, k), y = lerp(A.y, B.y, k), l = lerp(A.l, B.l, k) / 2, a = A.a + da * k;
        var cx = Math.cos(a) * l, cy = Math.sin(a) * l;
        // Vezels buigen: het middenpunt schuift loodrecht op de vezel
        var bend = lerp(A.b, B.b, k), mx = x - Math.sin(a) * bend, my = y + Math.cos(a) * bend;
        var n = p.n;
        n.setAttribute('d', 'M' + (x - cx).toFixed(1) + ' ' + (y - cy).toFixed(1) + 'Q' + mx.toFixed(1) + ' ' + my.toFixed(1) + ' ' + (x + cx).toFixed(1) + ' ' + (y + cy).toFixed(1));
        n.setAttribute('stroke-width', lerp(A.w, B.w, k).toFixed(2));
        n.setAttribute('stroke', rgb([lerp(A.c[0], B.c[0], k), lerp(A.c[1], B.c[1], k), lerp(A.c[2], B.c[2], k)]));
        n.setAttribute('opacity', lerp(A.o, B.o, k).toFixed(2));
      });
    }
    function setStep(i) {
      steps.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-pv-step') === i); });
    }
    // Labels over de tekening (HTML uit de Liquid, dus vertaalbaar)
    var bSound = box.querySelector('[data-pv-badge="sound"]'), bFire = box.querySelector('[data-pv-badge="fire"]');
    var fireRows = bFire ? bFire.querySelectorAll('[data-pv-row]') : [];
    function badges(snd, fir, rows) {
      if (bSound) bSound.classList.toggle('is-on', snd);
      if (bFire) bFire.classList.toggle('is-on', fir);
      for (var r = 0; r < fireRows.length; r++) fireRows[r].classList.toggle('is-on', r < rows);
    }

    // Tijdlijn (ms): elke fase even stil, dan in elkaar over. Op de
    // viltplaat volgen geluid (klasse A) en brand (B-s1,d0); daarna vervaagt
    // de plaat en staan de flessen er weer.
    var HOLD = 900, MORPH = 1100, END = 600, SOUND = 3000, FIRE = 4300, RESET = 600;
    var SEG = [HOLD, MORPH, HOLD, MORPH, HOLD, MORPH, END, SOUND, FIRE, RESET];
    var LOOP = SEG.reduce(function (a, b) { return a + b; }, 0);
    var clock = 0;
    function render(t) {
      clock = t;
      t = t % LOOP;
      var phase = 0, local = 0, seg = SEG, i, acc = 0;
      for (i = 0; i < seg.length; i++) { if (t < acc + seg[i]) { phase = i; local = (t - acc) / seg[i]; break; } acc += seg[i]; }
      var bo = 0, so = 0, step = 0;
      if (phase === 0) { drawParts(0, 0, 0); bo = 1; step = 0; }
      else if (phase === 1) { drawParts(0, 1, local); bo = 1 - clamp(local / 0.45); step = local < 0.5 ? 0 : 1; }
      else if (phase === 2) { drawParts(1, 1, 1); step = 1; }
      else if (phase === 3) { drawParts(1, 2, local); step = local < 0.5 ? 1 : 2; }
      else if (phase === 4) { drawParts(2, 2, 1); step = 2; }
      else if (phase === 5) { drawParts(2, 3, local); so = clamp((local - 0.35) / 0.6); step = local < 0.5 ? 2 : 3; }
      else if (phase === 6) { drawParts(3, 3, 1); so = 1; step = 3; }
      else if (phase === 7) { drawParts(3, 3, 1); so = 1; step = 4; }
      else if (phase === 8) { drawParts(3, 3, 1); so = 1; step = 5; }
      else { drawParts(3, 3, 1); so = 1 - clamp(local / 0.6); bo = clamp((local - 0.45) / 0.55); step = 0; }
      drawSound(phase === 7 ? local : 0, clock);
      drawFire(phase === 8 ? local : phase === 9 ? 1 : 0, clock);
      fire.setAttribute('opacity', phase === 9 ? so.toFixed(2) : 1);
      badges(phase === 7 && local > 0.3, phase === 8 && local > 0.12, phase === 8 ? (local > 0.78 ? 3 : local > 0.66 ? 2 : local > 0.56 ? 1 : 0) : 0);
      bottles.setAttribute('opacity', bo.toFixed(2));
      bottles.setAttribute('transform', 'translate(0 ' + ((1 - bo) * 10).toFixed(1) + ')');
      slab.setAttribute('opacity', so.toFixed(2));
      setStep(step);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      drawParts(3, 3, 1); bottles.setAttribute('opacity', 0); slab.setAttribute('opacity', 1);
      drawSound(0, 0); drawFire(0, 0); badges(true, true, 3);
      steps.forEach(function (s) { s.classList.add('is-active'); });
      return;
    }
    var raf = 0, t0 = 0;
    function frame(now) {
      if (!t0) t0 = now;
      render(now - t0);
      raf = requestAnimationFrame(frame);
    }
    render(0);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !raf) { t0 = 0; raf = requestAnimationFrame(frame); }
        else if (!e.isIntersecting && raf) { cancelAnimationFrame(raf); raf = 0; }
      });
    }, { threshold: 0.35 }).observe(svg);
  }

  function boot() { document.querySelectorAll('[data-paneel-vilt]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
